import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7cfa8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rank-main" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "list"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "paper-icon" }
const _hoisted_6 = {
  key: 0,
  src: "https://cdn.xesvip.cn/miniProgram/wechat/image/paper/single-paper.png"
}
const _hoisted_7 = {
  key: 1,
  src: "https://cdn.xesvip.cn/miniProgram/wechat/image/paper/multi-paper.png"
}
const _hoisted_8 = { class: "paper-main" }
const _hoisted_9 = { class: "paper-title" }
const _hoisted_10 = { class: "paper-info" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "see" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "empty" }

import { ref, computed, onMounted, onBeforeMount,watch,reactive } from "vue";
import { queryMyPaperList, queryMultiDetail } from '@/api/index'
import MultiPaperDetail from '@/components/paper/MultiPaperDetail.vue'
import { useRouter } from "vue-router";
import { queryExampaperList } from '@/api/index'
import dayjs from 'dayjs';
import NoData from "@/components/pub/NoData.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'rankList',
  props: {
  // 试卷列表
  data: {
    type: Array,
    default: () => [],
  },
  rankType:{
    type: Number,
    default: () => 3,
  },
  selectParams:{
    type: Object,
    default: () => {},
  },
  from:{
    type: String,
    default: () => '',
  },
  entrance:{
    type: String,
    default: '空',
  },
},
  emits: ["detail"],
  setup(__props, { emit: emits }) {

const props = __props;

const router = useRouter();


watch(props, (prop) => {
  if (prop.selectParams) {
    getParams()
  }
});
const packInitInfo = {
  title: '',
  paper_num: 0,
  detail: ''
}
const packPaperInfo = reactive(packInitInfo) // 套卷详情
const showMultiPaperDetail = ref(false)
const packPaperTime = ref('')
const packPaperList = ref([]) // 套卷列表
// 套卷查询
const getMultiDetail = (id) => {
  if (!id) {
    // 数据错误
    return
  }
  packPaperList.value = []
  Object.assign(packPaperInfo, packInitInfo)
  queryMultiDetail({
    pack_unionid: id
  }).then(res => {
    const {info, pack_paper_content: list} = res.data
    packPaperList.value = list || []
    Object.assign(packPaperInfo, info || {})
    showMultiPaperDetail.value = true
  }).catch(err => {
    console.log(err)
  })
}
// 关闭套卷弹窗
const handleCloseMultiPaperDetail = () => {
  showMultiPaperDetail.value = false
}

const count = ref(0)
const load = () => {
  count.value += 2
}
const listData = ref([])
let queryData = {}
const getParams = () => {
  
  // 热门榜 1  名校 3
  let defaultSchoolData = {
        "grade_group_id": 1,
        "key_word": "",
        "position_id": "3",
        "subject": "2",
        "page_info": {
            "count": 0,
            "limit": 10,
            "max_page": 0,
            "page": 1
        },
        "school_type":'1'
    }
  let hotData = {
        "grade_group_id": 1,
        "key_word": "",
        "position_id": "1",
        "subject": "2",
        "page_info": {
            "count": 0,
            "limit": 10,
            "max_page": 0,
            "page": 1
        },
    }
    
  queryData = JSON.parse(window.localStorage.getItem('queryParamsData')) || {}
  queryData = props.rankType === 3 ? {...defaultSchoolData,...queryData} : {...hotData,...queryData}
  if(props.rankType === 3){
    delete queryData?.key_word
    delete queryData?.classify
    delete queryData?.semester
    delete queryData?.difficulty
    delete queryData?.year
    queryData.school_type = '1'
    // classify province semester
  }
  // console.log(queryData,'query')
  queryExampaperListApi(queryData)
}
const queryExampaperListApi = (data) => {
  // console.log(data,'data111')
    queryExampaperList(data).then((res)=>{
        listData.value = res.data.list
        // console.log(res)
    })
}
const jump = (item:any) => {
  if (item.paper_type === 1) {
    // 单卷
    const url = router.resolve({
      path: 'single-paper',
      query: {
        'paper_id': item.id,
         entrance: props.entrance
      }
    });
    window.open(url.href, '_blank');
    emits('detail', item)
  } else {
    // 套卷弹窗
    packPaperTime.value = dayjs(item?.timestamp * 1000).format('YYYY-MM-DD')
    const { id } = item
    getMultiDetail(id)

  }
}
onMounted(() => {
  if(props.from !== 'homePage'){
    getParams()
  }
  // getParams()
   
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.rankType === 3 ? '本地名校' : '大家都在看'), 1),
      (listData.value?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value?.slice(0,6), (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item",
                key: i,
                onClick: ($event: any) => (jump(item))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (item?.paper_type === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item?.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(dayjs)(_ctx.create_time).format('YYYY/MM/DD')), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item?.views) + "浏览", 1)
                  ])
                ])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(NoData)
            ])
          ]))
    ]),
    _createVNode(MultiPaperDetail, {
      show: showMultiPaperDetail.value,
      "pack-paper-info": packPaperInfo,
      "pack-paper-list": packPaperList.value,
      onOnClose: handleCloseMultiPaperDetail
    }, null, 8, ["show", "pack-paper-info", "pack-paper-list"])
  ], 64))
}
}

})